// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageDivImageRating {
    width: 100%;
}

.marginTop25 {
    margin-top: 25px;
}

.marginLeft10 {
    margin-left: 10px;
}

.imageRatingInfoDiv {
    display: flex;
    flex-wrap: wrap;
}

.margin10{
    margin: 10px;
}

.borderRadius50 {
    border-radius: 50px;
}

.ratingNumberDiv {
    margin: 3% 0 1% 5%;
}

.ratingNumberDiv1 {
    margin: 0 0 3% 5%;
}

/* .actionButtonDiv {
    margin-left: 7%;
    margin-top: 2%;
} */

.borderRadius10 {
    border-radius: 10px;
}

.marginLeft30 {
    margin-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/ImageRating.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;GAGG;;AAEH;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".imageDivImageRating {\n    width: 100%;\n}\n\n.marginTop25 {\n    margin-top: 25px;\n}\n\n.marginLeft10 {\n    margin-left: 10px;\n}\n\n.imageRatingInfoDiv {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.margin10{\n    margin: 10px;\n}\n\n.borderRadius50 {\n    border-radius: 50px;\n}\n\n.ratingNumberDiv {\n    margin: 3% 0 1% 5%;\n}\n\n.ratingNumberDiv1 {\n    margin: 0 0 3% 5%;\n}\n\n/* .actionButtonDiv {\n    margin-left: 7%;\n    margin-top: 2%;\n} */\n\n.borderRadius10 {\n    border-radius: 10px;\n}\n\n.marginLeft30 {\n    margin-left: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
